document.addEventListener('DOMContentLoaded', function () {
  const navContainer = document.querySelector('.wp-block-navigation__responsive-container.hidden-by-default')
  const headerSocials = document.querySelector('.header__socials')
  const listMobileMenuBtnToggle = document.querySelectorAll('.mobile-header .wp-block-navigation-submenu__toggle')
  const mobileSearchForm = document.querySelector('.mobile-search')
  const mobileSearchButton = mobileSearchForm.querySelector('.wp-block-search__button')

  if (mobileSearchForm && mobileSearchButton) {
    mobileSearchButton.addEventListener('click', () => {
      mobileSearchForm.classList.add('is-active')
    })
  }

  if (listMobileMenuBtnToggle.length) {
    listMobileMenuBtnToggle.forEach(btn => {
      btn.removeAttribute('data-wp-on-async--click')
      btn.addEventListener('click', () => {
        if (btn.getAttribute('aria-expanded') === 'true') {
          btn.setAttribute('aria-expanded', 'false')
        } else {
          listMobileMenuBtnToggle.forEach(btn2 => {
            btn2.setAttribute('aria-expanded', 'false')
          })
          btn.setAttribute('aria-expanded', 'true')
        }
      })
    })
  }

  if (navContainer && headerSocials) {
    setTimeout(() => {
      const clonedHeaderSocials = headerSocials.cloneNode(true)
      navContainer.append(clonedHeaderSocials)
    }, 500)
  }

  const updateSubCatsPosition = () => {
    let trending = document.querySelector('.js-oak-trending-cheapism')
    let asideBox = document.querySelector('.js-oak-aside-box')
    let sidebar = document.querySelector('.single-sidebar')
    let adBox = document.querySelector('.js-oak-group-ad-box')
    let subCats = document.querySelector('.js-oak-aside-sub-cats')
    let article = document.querySelector('.article-wrapper')

    if (!asideBox || !sidebar) return;

    // --- Case 1: exist trending ---
    if (trending) {
      const trendingRect = trending.getBoundingClientRect()
      const sidebarRect = sidebar.getBoundingClientRect()
      asideBox.style.top = (trendingRect.top - sidebarRect.top) + 'px'

      if (subCats && subCats.style.visibility === 'hidden') {
        subCats.style.visibility = 'visible'
      }
    }
    // --- Case 2: not exist trending ---
    else if (subCats && article) {
      const children = Array.from(article.children)
      if (children.length === 0) return

      const articleRect = article.getBoundingClientRect()
      const articleCenter = articleRect.top + articleRect.height / 2

      // find element child have top near center
      let centerElement = children[0]
      let minDiff = Math.abs(children[0].getBoundingClientRect().top - articleCenter)

      for (let child of children) {
        const diff = Math.abs(child.getBoundingClientRect().top - articleCenter)
        if (diff < minDiff) {
          minDiff = diff
          centerElement = child
        }
      }

      const centerRect = centerElement.getBoundingClientRect()
      const sidebarRect = sidebar.getBoundingClientRect()

      asideBox.style.top = (centerRect.top - sidebarRect.top) + 'px'

      if (subCats.style.visibility === 'hidden') {
        subCats.style.visibility = 'visible'
      }
    }

    // --- Sticky logic for adBox ---
    if (subCats && adBox) {
      asideBox.style.setProperty('position', 'absolute', 'important')

      const subCatsRect = subCats.getBoundingClientRect()
      const adBoxRect = adBox.getBoundingClientRect()
      const articleRect = article ? article.getBoundingClientRect() : null
      const offsetTop = 20

      if (subCatsRect.bottom <= offsetTop && window.innerWidth >= 782) {
        const adHeight = adBoxRect.height || 0

        if (articleRect && (articleRect.bottom - adHeight) <= offsetTop) {
          // absolute in asideBox when end article bottom
          const asideBoxRect = asideBox.getBoundingClientRect()
          const absoluteTop = (articleRect.bottom + window.scrollY) - adHeight - (asideBoxRect.top + window.scrollY)

          adBox.style.position = 'absolute'
          adBox.style.top = Math.max(0, absoluteTop) + 'px'
          adBox.style.bottom = ''
          adBox.style.left = ''
          adBox.style.width = sidebar.getBoundingClientRect().width + 'px'
        } else {
          // sticky normal
          adBox.style.position = 'fixed'
          adBox.style.left = subCatsRect.left + 'px'
          adBox.style.width = sidebar.getBoundingClientRect().width + 'px'
          adBox.style.top = offsetTop + 'px'
          adBox.style.bottom = ''
        }
      } else {
        // reset
        adBox.style.position = ''
        adBox.style.top = ''
        adBox.style.bottom = ''
        adBox.style.left = ''
        adBox.style.width = ''
      }
    }
  }

  // Hide subcats initially
  const subCatsInit = document.querySelector('.js-oak-aside-sub-cats')




  window.addEventListener('load', updateSubCatsPosition)
  window.addEventListener('resize', updateSubCatsPosition)
  window.addEventListener('scroll', updateSubCatsPosition, { passive: true })

  // Clone sidebar and add to middle list card-items on Page News Template
  const sidebarNewsTpl = document.querySelector('.tpl-news-main .js-oak-group-ad-box')
  const listCardItems = document.querySelector('.tpl-news-main .news-list-card-item')
  if (sidebarNewsTpl && listCardItems) {
    const clonedSidebar = sidebarNewsTpl.cloneNode(true)
    clonedSidebar.classList.add('mobile-sidebar')
    clonedSidebar.classList.remove('js-oak-group-ad-box')
    sidebarNewsTpl.classList.add('desktop-sidebar')
    const cardItems = listCardItems.querySelectorAll('.card-item')

    if (cardItems && cardItems.length) {
      let uniqueGroups = new Set()
      cardItems.forEach(card => {
        let parentGroup = card.closest('.wp-block-group')
        if (parentGroup) {
          uniqueGroups.add(parentGroup)
        }
      })

      let groupList = Array.from(uniqueGroups)

      if (groupList.length > 0 && groupList.length > 4) {
        const middleIndex = Math.floor(groupList.length / 2)
        listCardItems.insertBefore(clonedSidebar, groupList[middleIndex])
      } else {
        listCardItems.insertBefore(clonedSidebar, groupList[groupList.length])
      }
    }
  }

  // Clone sidebar and add to middle list posts on Author page
  const sidebarAuthorPage = document.querySelector('.archive.author .js-oak-group-ad-box')
  const listAuthorPosts = document.querySelector('.archive.author .author-list-post')
  if (sidebarAuthorPage && listAuthorPosts) {
    const clonedSidebar = sidebarAuthorPage.cloneNode(true)
    clonedSidebar.classList.add('mobile-sidebar')
    clonedSidebar.classList.remove('js-oak-group-ad-box')
    sidebarAuthorPage.classList.add('desktop-sidebar')
    const authorCardPosts = listAuthorPosts.querySelectorAll('.wp-block-post')

    if (authorCardPosts && authorCardPosts.length > 0) {
      let uniqueAuthorGroups = new Set()
      authorCardPosts.forEach(item => {
        if (item) {
          uniqueAuthorGroups.add(item)
        }
      })

      let groupList = Array.from(uniqueAuthorGroups)

      if (groupList.length > 0 && groupList.length > 4) {
        const middleIndex = Math.floor(groupList.length / 2)
        listAuthorPosts.insertBefore(clonedSidebar, groupList[middleIndex])
      } else {
        listAuthorPosts.insertBefore(clonedSidebar, groupList[groupList.length])
      }
    }
  }

  // Validate Form submit
  const newLetterForms = document.querySelectorAll('.js-validate-form')
  if (newLetterForms && newLetterForms.length) {
    newLetterForms.forEach(form => {
      const input = form.querySelector('input[type="email"]')
      const errorDiv = form.querySelector('.js-error-message')
      const response = form.querySelector('.js-response-message')

      form.addEventListener('submit', async (e) => {
        e.preventDefault()
        const emailValue = input.value.trim()
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        form.classList.add('loading')

        if (!emailRegex.test(emailValue)) {
          form.classList.remove('loading')
          errorDiv.textContent = ''
          response.textContent = ''
          errorDiv.textContent = 'Please enter a valid email address.'
          input.classList.add('has-error')
        } else {
          errorDiv.textContent = ''
          input.classList.remove('has-error')

          try {
            const res = await fetch('/wp-json/custom/v1/subscribe', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email : emailValue })
            })
            const data = await res.json()
            errorDiv.textContent = ''
            response.textContent = ''
            response.textContent = data.message || data.error
            input.value = ''
          } catch (err) {
            errorDiv.textContent = ''
            response.textContent = ''
            errorDiv.textContent = 'Error, please try again.'
          }
          form.classList.remove('loading')
        }
      })
    })
  }

  // In The News
  const inTheNewsEls = document.querySelectorAll('.js-in-the-news')
  if (inTheNewsEls && inTheNewsEls.length) {
    inTheNewsEls.forEach(el => {
      const btn = el.querySelector('.js-btn')
      const items = el.querySelectorAll('.js-item')
      if (btn && items && items.length) {
        btn.addEventListener('click', function () {
          items.forEach(item => {
            item.classList.remove('is-hidden')
          })
          btn.style.display = 'none'
        })
      }
    })
  }

  // ADA - Add attribute aria-label for link
  document.querySelectorAll('a').forEach(link => {
    const text = link.textContent.trim();
    if (text && !link.querySelector('img') && !link.hasAttribute('aria-label')) {
      link.setAttribute('aria-label', text);
    }
  });
  // ADA - Add attribute alt for img
  document.querySelectorAll('img').forEach(img => {
    let alt = img.getAttribute('alt');
    if (!alt || alt.trim() === "") {
      let src = img.getAttribute('src') || "";
      let fileName = src.split('/').pop().split('.')[0];
      if (fileName) {
        img.setAttribute('alt', fileName);
      }
    }
  });
})

//fix unwrapped text nodes in divs in post content
document.querySelectorAll('.article-wrapper').forEach(div => {
    // Convert NodeList to array to avoid live collection issues
    const childNodes = Array.from(div.childNodes);
    
    childNodes.forEach(node => {
        // Only target text nodes with actual content (not just whitespace)
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
            // Create a p tag or div to wrap the text
            const wrapper = document.createElement('p');
            wrapper.textContent = node.textContent;
            wrapper.style.marginBottom = '16px'; // Or whatever spacing you need
            
            // Replace the text node with the wrapped version
            div.replaceChild(wrapper, node);
        }
    });
});
